import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  TextField,
  Button,
  Divider,
  Stack,
  Paper,
  ThemeProvider,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import mainTheme from "../../../newComponent/themeprovider/mainTheme/MainTheme";
import { fDate } from "../../../../utils/formatTime";
import { useSnackbar } from "../../../components/ui-component/snackbar/SnackbarContext";
import { handleUpdateSubmittedAssignment } from "../services";

const RejectAssignment = ({ rowData, onClose }) => {
    const userId = localStorage.getItem("userId");
      const [reason, setReason] = useState("");
    const maxLength = 1000;
const { showSnackbar } = useSnackbar();
    const handleReasonChange = (e)=>{
  
  if (e.target.value.length <= maxLength) {
    setReason(e.target.value);
  
};

    }

    const handleDeclineAssignment =async () => {
       
        if(!reason){
            showSnackbar("Please Enter Reason", "error");
            return;
        }
        const requestData ={
         "user_id":parseInt(userId),
        "submitted_assign_id":rowData?.id,
        "reason_for_decline":reason,
       
        }
     try {
        const response = await  handleUpdateSubmittedAssignment(requestData);
    
        if(response.status === 200){
            showSnackbar("Assignment Updated Successfully");
             setTimeout(() => window.location.reload(), 1200);
        }
    
        else{
            showSnackbar(response?.message || "Update Failed", "error");
        }
        
     } catch (error) {
        console.error("Error updating assignment:", error);
        showSnackbar("Update Failed", "error");
        
     }
    };
  return (
    <>
      <ThemeProvider theme={mainTheme}>
        {/* Student Info */}
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Avatar sx={{ width: 50, height: 50 }} />
          </Grid>

          <Grid item xs>
            <Typography fontWeight={600}>{rowData?.sp_user_id?.first_name} {rowData?.sp_user_id?.last_name}</Typography>
            <Typography variant="body2" color="text.secondary">
              {rowData?.sp_user_id?.email} ({rowData?.sp_user_id?.mobile})
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="body2">
              Submitted Date : <br />
             Max Marks :
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="body2">
             {fDate (rowData?.submitted_date)} <br />
           {rowData?.assignment_id?.max_marks}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Assignment Name */}
        <Typography mb={2} variant="body2">
          <b>Assignment:</b> {rowData?.assignment_id?.title} ({
            rowData?.assignment_id?.assignment_type
          })
        </Typography>

        {/* Submitted File */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="body2">
            <b>Submitted File:</b>   {rowData?.assignment_object?.original_filename}
          </Typography>

          <Button
            variant="contained"
            size="small"
            startIcon={<DownloadIcon />}
              onClick={()=>window.open(rowData?.assignment_link, "_blank")}
            sx={{
              backgroundColor: "#F3D9A4",
              color: "#000",
              textTransform: "none",
              "&:hover": { backgroundColor: "#e7c888" },
            }}
          >
            Download
          </Button>
        </Stack>

        {/* Reject Reason */}
        <Typography fontWeight={500} mb={1} variant="body2">
          Reason for Decline:
        </Typography>

        <TextField
          multiline
          rows={4}
          fullWidth
          placeholder="Enter reason why this assignment is being rejected..."
          value={reason}
          onChange={handleReasonChange}
        />
        <Stack direction="row" justifyContent="flex-end">
          <Typography
            variant="caption"
            color={reason.length === maxLength ? "error" : "text.secondary"}
          >
            {reason.length} / {maxLength}
          </Typography>
        </Stack>

        {/* Footer Buttons */}
        <Stack direction="row" justifyContent="flex-end" spacing={2} mt={3}>
          <Button
            variant="outlined"
            size="small"
            color="error"
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button variant="contained" size="small" color="error" onClick={handleDeclineAssignment}>
            Decline Assignment
          </Button>
        </Stack>
      </ThemeProvider>
    </>
  );
};

export default RejectAssignment;
